module.exports = __webpack_public_path__ + "img/sj.18e5dd43.png";